import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const Search = () => {
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    const query = searchParams.get('q');
    if (query) {
      // Redirect to Yahoo search with 302 redirect
      window.location.replace(`https://search.yahoo.com/search?p=${encodeURIComponent(query)}`);
    } else {
      // If no query parameter, redirect to homepage
      window.location.replace('/');
    }
  }, [searchParams]);

  // Show loading while redirecting
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to search...</p>
      </div>
    </div>
  );
};

export default Search;